import React from 'react';
import { useNavigate } from 'react-router-dom';
import './terms.css';
import logo from './apnaghar.png'; // small logo inside the card
import { FaBuilding, FaUserCheck, FaExclamationTriangle, FaMoneyBillWave, FaShieldAlt, FaBan, FaGavel } from 'react-icons/fa';

const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="terms-container">
      <div className="back-logo">
        <button className="back-btn" onClick={() => navigate(-1)}>← Back</button>
        <img src={logo} alt="GharSeGhar Logo" className="terms-logo" />
      </div>

      <div className="terms-card">
        {/* Small logo inside the card */}
        <div className="card-logo">
          <img src={logo} alt="GharSeGhar Logo" />
        </div>

        <h1>Terms & Conditions (User Agreement)</h1>
        <p><strong>Effective Date:</strong> 08/08/2025</p>
        <p><strong>Company Name:</strong> ApkaGhr</p>

        <p>
          By using our platform to view or list rental properties (the “Service”), 
          you agree to the following terms:
        </p>

        <div className="terms-section">
          <h2><FaBuilding className="icon"/> 1. Platform Role</h2>
          <ul>
            <li>We act only as an intermediary to connect property owners and tenants.</li>
            <li>We do not own, manage, or control any property listed on our platform.</li>
            <li>Our responsibility ends once the user contacts the owner or visits the property.</li>
          </ul>
        </div>

        <div className="terms-section">
          <h2><FaUserCheck className="icon"/> 2. User Responsibilities</h2>
          <ul>
            <li>Users must provide accurate and truthful information while creating listings or making inquiries.</li>
            <li>Users are solely responsible for verifying the details of the property, including rent, amenities, safety, and legal ownership, before making any commitments.</li>
            <li>Users agree to respect the rights of property owners and tenants and comply with all applicable laws.</li>
          </ul>
        </div>

        <div className="terms-section">
          <h2><FaExclamationTriangle className="icon"/> 3. No Liability for Disputes</h2>
          <ul>
            <li>Any dispute, disagreement, or issue arising between property owners and tenants is not our responsibility.</li>
            <li>We shall not be liable for any loss, damage, or expense incurred by users as a result of using our platform.</li>
          </ul>
        </div>

        <div className="terms-section">
          <h2><FaMoneyBillWave className="icon"/> 4. Payments & Agreements</h2>
          <ul>
            <li>We are not responsible for payment collection or rental agreements between tenants and owners.</li>
            <li>Users must directly negotiate and finalize terms with the property owner.</li>
          </ul>
        </div>

        <div className="terms-section">
          <h2><FaShieldAlt className="icon"/> 5. Fraud Prevention</h2>
          <ul>
            <li>We may review or verify information but cannot guarantee accuracy or legality of listings.</li>
            <li>Users are advised to exercise due diligence before making payments or commitments.</li>
          </ul>
        </div>

        <div className="terms-section">
          <h2><FaBan className="icon"/> 6. Termination of Use</h2>
          <ul>
            <li>We reserve the right to suspend or terminate any user account violating these Terms.</li>
          </ul>
        </div>

        <div className="terms-section">
          <h2><FaGavel className="icon"/> 7. Governing Law</h2>
          <ul>
            <li>These Terms shall be governed by and interpreted in accordance with the laws of [Insert Country/State].</li>
          </ul>
        </div>

        <p className="company-footer">
          © {new Date().getFullYear()} Apkaghr. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
